// |--------------------------------------------------------------------------
// |ユーザー情報
// ログイン認証時に取得したユーザー情報を格納します

// vue側で呼び出す場合は import 任意の変数名 from "@/stubs/〇〇.js";と記載します
// 例：demo.id

// オブジェクトの中身を変数に格納する場合は「...test」とする
// 例：const test = {...test};
// |--------------------------------------------------------------------------

/* ---------------------------------------------------------------------------
営業
---------------------------------------------------------------------------- */
export const form = {
	id: "",
	type: [],
	management_type: "",
	category: "",
	company_name: "",
	corporate_number: "",
	zip1: "",
	zip2: "",
	address: "",
	tel: "",
	fax: "",
	name: "",
	skill_staff_name: "",
	spec_skill_staff_name: "",
	company_url: "",
	skill_staff_email: [],
	spec_skill_staff_email: [],
	status: "",
	call_result: "",
	estimate: "",
	no_estimate: "",
	post_meeting_status: "",
	management_method: "",
	other_management_method: "",
	has_specific_skill: "",
	meeting_month: "",
	usage_status: "",
	cancellation_reason: "",
	download_document: "",
	download_month: "",
	remarks: "",
	application_month: "",
	approval_date: "",
	approval_deadline: "",
	receiving_country: [],
	caregiver_job_availability: "",
	business_availability: ""
};

// 技能の値をクリア
export const formatClear1 = {
	category: "",
	spec_skill_staff_name: "",
	spec_skill_staff_email: [],
	application_month: "",
	usage_status: "",
	cancellation_reason: "",
	download_document: "",
	download_month: "",
	remarks: ""
};

// 特定技能の値をクリア
export const formatClear2 = {
	management_type: "",
	skill_staff_name: "",
	skill_staff_email: [],
	approval_date: "",
	approval_deadline: "",
	receiving_country: [],
	caregiver_job_availability: "",
	business_availability: "",
	status: "",
	call_result: "",
	estimate: "",
	no_estimate: "",
	post_meeting_status: "",
	management_method: "",
	other_management_method: "",
	has_specific_skill: "",
	meeting_month: ""
};
